import type {
    FC
} from "react";
import type IQuestionnaireProgressProps from "./type";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import type {
    QuestionnairePartContentProps
} from "../../type";
import {
    formatNumber
} from "../../../../helpers/locale";
import {
    withQuestionnaireContext
} from "../../context";
import Progress from "../../../progress";
import Card from "../../../card";

const QuestionnaireProgressContent: FC<QuestionnairePartContentProps<IQuestionnaireProgressProps>> = ({
    customTheme: customThemeProp,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        activeLocale,
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const itemCount = context.items.length;

    const valueFormatter = (value: number, max: number) => {
        if(context.isReview) {
            return localize("questionnaire-review");
        }

        return localize("questionnaire-question-count", [
            formatNumber({
                locale: activeLocale,
                value
            }),
            formatNumber({
                locale: activeLocale,
                value: max
            })
        ]);
    };

    if(!itemCount) {
        return null;
    }

    return <Card.Content>
        <Progress
            {...props}
            value={context.isReview ? itemCount : context.activeIndex + 1}
            customLocalize={context.customLocalize}
            valueFormatter={valueFormatter}
            customTheme={customTheme}
            title={context.title}
            variant="segmented"
            steps={itemCount}
            style={style}
            size="small"
        />
    </Card.Content>;
};
export default withQuestionnaireContext("Progress", QuestionnaireProgressContent);
